import get from 'lodash/get';
import set from 'lodash/set';

const deepReduceObject = (object, structure) => {
  const obj = {};

  structure.forEach((key) => {
    set(obj, key, get(object, key));
  });

  return obj;
};

export const flattenAccountsTree = (accountObject) => {
  let list = [];

  const traverse = (account) => {
    list.push(deepReduceObject(account, ['id', 'name', 'parentId']));

    if ((account.children || []).length) {
      account.children.forEach((child) => traverse(child));
    }
  };

  if (accountObject) {
    traverse(accountObject);
  }

  return list;
};

export const getParents = (list, node) => {
  let collect = [];

  const lookupParent = (node) => {
    if (node.parentId === null) {
      return collect;
    }

    const parent = list
      .filter((item) => {
        return item.id === node.parentId;
      })
      .pop();

    if (!parent) {
      return collect;
    }

    collect.push(parent.id);

    return lookupParent(parent);
  };

  return lookupParent(node);
};
